import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import TotalPanel from './TotalPanel'
import InvestmentCountPanel from './InvestmentCountPanel'
import StakeholdersCountPanel from './StakeholdersCountPanel'
import SroiInfoPanelsSkeleton from './Skeleton'

import { usePdfExport } from '../../PdfExportContext'

import { socialReturnOnInvestmentReportWasLoadedSelector } from '../../../../../modules/selectors/socialReturnOnInvestment'

import { pdfExportComponentKeys } from '../../constants'

import useStyles from './styles'

const SroiInfoPanels = ({ isExportCopy }) => {
  const classes = useStyles()
  const reportWasLoaded = useSelector(socialReturnOnInvestmentReportWasLoadedSelector)
  const { signalComponentReady } = usePdfExport()

  // Signal ready for PDF export when the export copy is mounted
  useEffect(() => {
    if (isExportCopy && reportWasLoaded) {
      signalComponentReady(pdfExportComponentKeys.sroiInfoPanels)
    }
  }, [isExportCopy, reportWasLoaded, signalComponentReady])

  if (!reportWasLoaded) {
    return <SroiInfoPanelsSkeleton />
  }

  return (
    <div className={classes.container}>
      <TotalPanel />
      <InvestmentCountPanel />
      <StakeholdersCountPanel />
    </div>
  )
}

SroiInfoPanels.propTypes = {
  isExportCopy: PropTypes.bool
}

export default SroiInfoPanels
